// Extracted verbatim from the v3 monolith (see BIRDSEYE.md module split plan).

import { normalizeText, callHook, dispatchEventSafe } from './utils.js';
import { showNode } from './ui-state.js';

export var _renderItems = function (visibleItems) {
  var beforeRects = this._shouldAnimate() ? this._captureVisibleRects() : null;
  var visibleSet = new Set(
    visibleItems.map(function (record) {
      return record.id;
    })
  );
  var stableItems = [];
  var enteringItems = [];
  var shouldReinitIx = false;
  var mountFragment = this.mountVisibleOnly ? document.createDocumentFragment() : null;

  this._muteMutations();
  try {
    this.items.forEach(
      function (record) {
        var isMounted = !!(this.list && this.list.contains(record.el));
        var wasVisible = this._isVisibleInDom(record.el);
        var shouldShow = visibleSet.has(record.id);

        if (shouldShow) {
          record.el.style.display = '';
          record.el.hidden = false;
          record.el.setAttribute('aria-hidden', 'false');

          if (wasVisible) {
            stableItems.push(record);
          } else {
            enteringItems.push(record);
          }

          if (this.mountVisibleOnly && mountFragment) {
            mountFragment.appendChild(record.el);
          }

          if (!isMounted && record.el.__pfNeedsIxInit) {
            shouldReinitIx = true;
            record.el.__pfNeedsIxInit = false;
          }
        } else {
          this._stopElementAnimation(record.el);

          if (this.mountVisibleOnly) {
            if (isMounted && record.el.parentNode) {
              record.el.parentNode.removeChild(record.el);
            }
            record.el.hidden = true;
            record.el.setAttribute('aria-hidden', 'true');
          } else {
            record.el.style.display = 'none';
            record.el.hidden = true;
            record.el.setAttribute('aria-hidden', 'true');
          }
        }
      }.bind(this)
    );

    if (this.mountVisibleOnly && mountFragment && this.list) {
      this.list.appendChild(mountFragment);
    }
  } finally {
    this._unmuteMutationsAsync();
  }

  if (beforeRects && this._shouldAnimate()) {
    this._animateItems(beforeRects, stableItems, enteringItems);
  }

  if (shouldReinitIx && window.Webflow && typeof window.Webflow.require === 'function') {
    try {
      var ix2 = window.Webflow.require('ix2');
      if (ix2 && typeof ix2.init === 'function') {
        ix2.init();
      }
    } catch (_error) {
      // Optional Webflow re-init; ignore when unavailable.
    }
  }
};

export var _updateCounts = function () {
  var total = this.items.length;
  var filtered = this.filteredItems.length;

  this.countNodes.forEach(function (node) {
    var type = normalizeText(node.getAttribute('data-pf-count'));
    var nextValue = type === 'total' ? total : filtered;
    var textValue = String(nextValue);

    if (!node.hasAttribute('aria-live')) {
      node.setAttribute('aria-live', 'polite');
    }

    if (node.textContent !== textValue) {
      node.textContent = textValue;
    }
  });
};

export var _render = function (payload) {
  callHook(this.hooks.onBeforeRender, payload, this);
  dispatchEventSafe(this.wrapper, 'panda:render:before', payload);

  var visibleItems = this._paginate();

  this._renderItems(visibleItems);
  this._renderPagination();
  this._updateCounts();
  this._updateFacetCounts(payload.state);
  this._updateEmptyOptions();
  this._renderTags(payload.state);
  var isBusy = !!(this.isLoading || this.isPreloading || this.isProgressLoading);
  showNode(this.emptyNode, this.filteredItems.length === 0 && !isBusy);
  this._refreshLoadButtonState();
  this._refreshInfiniteState();

  callHook(this.hooks.onAfterRender, payload, this);
  dispatchEventSafe(this.wrapper, 'panda:render:after', {
    visible: visibleItems.length,
    totalFiltered: this.filteredItems.length,
    page: this.currentPage,
    totalPages: this.totalPages,
  });

  this._debugLog('render:done', {
    reason: payload.reason,
    visible: visibleItems.length,
    filtered: this.filteredItems.length,
    total: this.items.length,
    page: this.currentPage,
    totalPages: this.totalPages,
  });
};

